import { postDataPoliciesImpactPreview } from '@ipfabric/api-client/client/model/rbac-—-data-policies/rbac-—-data-policies';
import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import {
  type DataPolicyTermValues,
  isCompleteCondition,
  toCondition,
} from './dataPolicyFormSchema';

const PREVIEW_DEBOUNCE_MS = 400;

/** Live dry-run count of entities the edited (unsaved) condition would admit. */
export const useImpactPreview = (
  snapshotId: string | null,
  terms: readonly DataPolicyTermValues[],
) => {
  const [debouncedTerms, setDebouncedTerms] = useState(terms);

  useEffect(() => {
    const timer = setTimeout(
      () => setDebouncedTerms(terms),
      PREVIEW_DEBOUNCE_MS,
    );
    return () => clearTimeout(timer);
  }, [terms]);

  const complete = isCompleteCondition(debouncedTerms);
  return useQuery({
    queryKey: ['/data-policies/impact/preview', snapshotId, debouncedTerms],
    queryFn: () =>
      postDataPoliciesImpactPreview({
        snapshotId: snapshotId ?? '',
        condition: toCondition(debouncedTerms),
      }),
    enabled: snapshotId !== null && complete,
  });
};
